import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OmsServiceService } from '../services/oms-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-pre-assessment-form',
  templateUrl: './pre-assessment-form.component.html',
  styleUrls: ['./pre-assessment-form.component.scss'],
})
export class PreAssessmentFormComponent implements OnInit {
  constructor(
    public modal: NgbActiveModal,
    private fb: FormBuilder,
    private omsService: OmsServiceService,
    private SpinnerService: NgxSpinnerService,
    private toastr: ToastrService
    
  ) {}
  preAssessment_Form!: FormGroup;
  nursingAssessment_Form!: FormGroup;
  physioAssessment_Form!: FormGroup;
  @Input() assessmentData;
  reportUploadedFile:any;

  ngOnInit(): void {
    this.physioAssessment_Form = this.fb.group({
      name: ['', Validators.compose([Validators.required])],
      age: [''],
      gender: [''],
      dateOfVisit: [''],
      reasonForVisit: this.fb.array([]),
      otherReasonForVisit: [''],
      painLevel: [''],
      painNotes: [''],
      durationProblem: [''],
      otherDuration: [''],
      medicalHistory: this.fb.array([]),
      otherMedicalHis: [''],
      dailyActivities: [''],
      activitiesDetails: [''],
      activitiesNotes: [''],
      movementPain: [''],
      detailsMovementPain: [''],
      movementPainNotes: [''],
      rangeMotion: [''],
      upperLimbsStrength: [''],
      lowerLimbsStrength: [''],
      strengthNotes: [''],
      therapyGoals: this.fb.array([]),
      detailsTherapyGoals: [''],
      recommendedTherapy: this.fb.array([]),
      detailsRecommendedTherapy: [''],
      recommendedTherapyNotes: [''],
      sessionsFrequency: [''],
      detailsSessionsFrequency: [''],
      frequencyNotes: [''],
    });

    this.nursingAssessment_Form = this.fb.group({
      // name:['', Validators.compose([Validators.required,]),],
      // age:[''],
      // gender:[''],
      // contactDetails:[''],
      // eMail:[''],
      aboutFeelings: [''],
      // detailsFeelings:[''],
      // aboutConcerns:[''],
      // otherConcerns:[''],
      aboutWeakness: [''],
      detailsWeakness: [''],
      aboutSwelling: [''],
      detailsSwelling: [''],
      aboutBreathing: [''],
      detailsBreathing: [''],
      aboutDigestion: [''],
      detailsDigestion: [''],
      aboutFatigued: [''],
      detailsFatigued: [''],
      aboutStress: [''],
      detailsStress: [''],
      // aboutSleepQuality:[''],
      detailsSleepQuality: [''],
      aboutMedications: [''],
      missedMedications: [''],
      aboutConfusion: [''],
      detailsConfusion: [''],
      bpSystolic: [''],
      bpDiastolic: [''],
      heartRate: [''],
      respiratoryRate: [''],
      oxygenSaturation: [''],
      temperature: [''],
      weight: [''],
      height: [''],
      bmi: [''],
    });
    this.preAssessment_Form = this.fb.group({
      name: ['', Validators.compose([Validators.required])],
      age: [''],
      gender: [''],
      contactDetails: [''],
      eMail: [''],
      sufferingFrom: this.fb.array([], Validators.required),
      otherSufferingDis: [''],
      recentlyHospitalized: [''],
      hospitalizedDetails: [''],
      underCarePhysician: [''],
      physicianCareDetails: [''],
      prescriptionDetails: [''],
      uploadPrescription: [''],
      regularMonitoring: this.fb.array([]),
      otherMonitoring: [''],
      symptomsDetails: this.fb.array([]),
      otherSymptoms: [''],
      mobilityAssistance: this.fb.array([]),
      otherMobilityDetails: [''],
      independentlyActivities: this.fb.array([]),
      medicationReminders: [''],
      dietaryRestrictions: this.fb.array([]),
      otherDietaryRestrictions: [''],
      asthmaDetails: [''],
      oxygenTherapy: [''],
      medicalDevices: this.fb.array([]),
      sleepingDifficulty: [''],
      memoryLoss: [''],
      anxietyDetails: [''],
      healthUpdatesName: [''],
      updatesContactNo: [''],
    });

    if (this.assessmentData.assessmentType == 'FRM_PRE_ASMT') {
      this.preAssessment_Form.patchValue({
        name: this.assessmentData.name,
        age: this.assessmentData.age,
        gender: this.assessmentData.gender,
        contactDetails: this.assessmentData.contactDetails,
        eMail: this.assessmentData.email,
      });
    } else if (this.assessmentData.assessmentType == 'FRM_PHY_ASMT') {
      this.physioAssessment_Form.patchValue({
        name: this.assessmentData.name,
        age: this.assessmentData.age,
        gender: this.assessmentData.gender,
      });
    }
  }
  get p() {
    return this.preAssessment_Form.controls;
  }
  modelClose() {
    this.modal.close();
  }

  bmiCalculator() {
    if (
      this.nursingAssessment_Form.value.weight != '' &&
      this.nursingAssessment_Form.value.height != ''
    ) {
      let bmi = (
        (this.nursingAssessment_Form.value.weight /
          (this.nursingAssessment_Form.value.height *
            this.nursingAssessment_Form.value.height)) *
        10000
      ).toFixed(2);
      this.nursingAssessment_Form.patchValue({
        bmi: bmi,
      });
    }
  }

  onCheckboxChange(event: any, field: string) {
    let selectedItems: any;
    if (this.assessmentData.assessmentType == 'FRM_NRS_ASMT') {
      selectedItems = this.nursingAssessment_Form.get(field) as FormArray;
    } else if (this.assessmentData.assessmentType == 'FRM_PRE_ASMT') {
      selectedItems = this.preAssessment_Form.get(field) as FormArray;
    } else if (this.assessmentData.assessmentType == 'FRM_PHY_ASMT') {
      selectedItems = this.physioAssessment_Form.get(field) as FormArray;
    }

    // if (event.target.value === 'none') {
    //   selectedItems.clear();
    //   return;
    // }

  // If "none" is selected, clear the FormArray and uncheck all checkboxes
  if (event.target.value === 'none' && event.target.checked) {
    selectedItems.clear();
    const checkboxes = document.querySelectorAll(`input[id="${field}"]`);
    checkboxes.forEach((checkbox: any) => {
      if (checkbox.value !== 'none') {
        checkbox.checked = false;
      }
    });
    return;
  }

    // Uncheck "none" if any other checkbox is selected
    if (event.target.value !== 'none' && event.target.checked) {
      const noneCheckbox = document.querySelector(`input[id="${field}"][value="none"]`) as HTMLInputElement;
      if (noneCheckbox) {
        noneCheckbox.checked = false;
      }
      const noneIndex = selectedItems.controls.findIndex((ctrl) => ctrl.value === 'none');
      if (noneIndex !== -1) {
        selectedItems.removeAt(noneIndex);
      }
    }

    if (event.target.checked) {
      selectedItems.push(this.fb.control(event.target.value));
    } else {
      const index = selectedItems.controls.findIndex(
        (ctrl) => ctrl.value === event.target.value
      );
      selectedItems.removeAt(index);
    }
  }

  assessmentFormSubmit() {
    let payload = {
      orderId: this.assessmentData.orderId,
      role: this.assessmentData.role,
      formCode: this.assessmentData.assessmentType,
      createdBy: this.assessmentData.actionById,
      orderdid:this.assessmentData.orderdid,
      parentOrderId:this.assessmentData.parentOrderId
      // "data": this.nursingAssessment_Form.value
    };
    if (this.assessmentData.assessmentType == 'FRM_NRS_ASMT') {
      payload['data'] = this.nursingAssessment_Form.value;
    } else if (this.assessmentData.assessmentType == 'FRM_PRE_ASMT') {
      payload['data'] = this.preAssessment_Form.value;
    } else if (this.assessmentData.assessmentType == 'FRM_PHY_ASMT') {
      payload['data'] = this.physioAssessment_Form.value;
    }
    this.SpinnerService.show()
    this.omsService.assessmentFormSubmit(payload).subscribe((res: any) => {
      this.SpinnerService.hide()
      if (res && res.status == 'success') {
        let data = {
          action: 'OMS/api/v6/order/tag',
          type: 'post',
          tenantCode: this.assessmentData.tenantCode,
          orgCode: this.assessmentData.orgCode,
          actionById: this.assessmentData.actionById,
          actionByName: this.assessmentData.actionByName,
          orderId: [this.assessmentData.orderId],
          tagType: 'assessmentCompleted'
        };
        this.SpinnerService.show()
        this.omsService.omsCommonMethod(data).subscribe((res: any) => {
          this.SpinnerService.hide()
          if (res && res.status == 1) {
            let response=res.data[this.assessmentData.orderId]
            if(response.status == 1){
              this.modelClose()
              this.toastr.success(response.message)
            }else{
              this.toastr.error(response.message)
            }

          }
        });
      }
    });
  }

  uploadReports(event: any) {
    
    this.reportUploadedFile = "";
    // this.documentId = "";
    if (event.target.files.length > 0) {
      this.reportUploadedFile = event.target.files[0]
      let formData: FormData = new FormData();
      formData.append('file', this.reportUploadedFile); 
      formData.append('document', this.reportUploadedFile);
      let cp = 'CP'
      let Prescription = 'dischargeSummary'
      formData.append('applicationName', cp);
      formData.append('documentType', Prescription);
      this.SpinnerService.show()
      this.omsService.uploadDocument(formData).subscribe((res: any) => {
        this.SpinnerService.hide()
        if (res.status == 'SUCCESS') {
          this.preAssessment_Form.patchValue({
            uploadPrescription : res.uploaded_document_id+""
          })
          console.log(this.preAssessment_Form.value)
          this.toastr.success(res.reason);
        } else {
          this.preAssessment_Form.patchValue({
            uploadPrescription : ""
          })
          this.toastr.error(res.reason);
          // alert(res.message)

        }
      } ,(err) => {
        // this.error = err;
        
      }
      
      )
    }
  }
}
